import { render, staticRenderFns } from "./addTurnoverTier.vue?vue&type=template&id=582ed536&lang=pug"
import script from "./addTurnoverTier.vue?vue&type=script&lang=js"
export * from "./addTurnoverTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports